import { apiGetDatosAlumnoQR } from "../../api/DataQR"

const getDatosQR = (context, folio) => {
  return new Promise((resolve, reject) => {
    apiGetDatosAlumnoQR(folio)
      .then(response => {
        context.commit('GET_DATOS', response.data)
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default { getDatosQR }